import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AlertComponent from "../../Components/AlertComponent";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import FetchHook from "../../Api/FetchHooks";
import { matchIsValidTel, MuiTelInput } from "mui-tel-input";
import Page from "../../Components/Page";
import { LoadingButton } from "@mui/lab";

const FindCustomer = () => {
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const msisdn = watch("msisdn");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [loading, , request] = FetchHook();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = async () => {
    try {
      if (
        (msisdn && msisdn.length < 13) ||
        (msisdn && msisdn.length > 13) ||
        msisdn === undefined
      ) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Enter a correct number",
        });
      } else {
        const response = await request({
          url: `entity?type=customer&filter_value=${msisdn.replaceAll(
            "+",
            ""
          )}`,
        });

        if (
          response &&
          response.status === 200 &&
          response.data.StatusCode === 0
        ) {
          setSnackbar({
            open: true,
            severity: "success",
            message: "Customer found successfully!",
          });
          setTimeout(() => {
            navigate("/dashboard/users/user-profile", {
              state: { user: response.data.Data[0] },
            });
          }, 500);
        } else {
          const errorMessage =
            response?.data?.StatusMessage ??
            response?.data?.message ??
            "An unexpected error occurred. Please try again.";

          setSnackbar({
            open: true,
            severity: "error",
            message: errorMessage,
          });
        }
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <Page>
      <Card
        sx={{
          p: "20px",
          width: { md: "500px", sm: "fit-content" },
        }}
      >
        <AlertComponent
          open={snackbar.open}
          handleSnackbar={handleSnackbarClose}
          severity={{ severity: snackbar.severity, message: snackbar.message }}
        />

        <CardHeader
          title={
            <Typography gutterBottom variant="h5" component="div">
              Member search
            </Typography>
          }
        />

        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid>
              <Controller
                name="msisdn"
                control={control}
                rules={{
                  required: true,
                  validate: (value) => matchIsValidTel(value),
                }}
                defaultValue={"+254"}
                render={({ field, fieldState }) => (
                  <MuiTelInput
                    {...field}
                    fullWidth
                    defaultCountry="KE"
                    onlyCountries={["KE"]}
                    helperText={
                      fieldState.invalid ? "Invalid mobile number!" : ""
                    }
                    error={fieldState.error}
                    value={field.value || ""}
                    disableFormatting
                  />
                )}
              />
            </Grid>

            <Grid container justifyContent="flex-end" alignItems="flex-end">
              <LoadingButton
                loading={loading}
                variant="contained"
                type="submit"
                size="large"
                sx={{
                  my: "20px",
                }}
              >
                search
              </LoadingButton>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Page>
  );
};

export default FindCustomer;
